import React, { useEffect, useState } from "react";
import api from "../../services/api";

const formatDate = value => {
  if (!value) return "-";

  return new Date(value).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

const RecoveryUpcomingSchedules = () => {
  const [loading, setLoading] = useState(false);
  const [schedules, setSchedules] = useState([]);

  const loadSchedules = async () => {
    setLoading(true);

    try {
      const { data } = await api.get("/dashboard/recovery/upcoming");
      setSchedules(data.schedules || []);
    } catch (error) {
      console.error("Erro ao carregar próximos disparos da régua:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSchedules();
  }, []);

  const openTicket = ticketUuid => {
    if (!ticketUuid) return;
    window.open(`/tickets/${ticketUuid}`, "_blank");
  };

  const cancelSchedule = async item => {
    const ok = window.confirm(
      `Cancelar o disparo para ${item.contactName || "este cliente"}?\n\nMensagem:\n${item.cleanMessage || ""}`
    );

    if (!ok) return;

    try {
      await api.put(`/dashboard/recovery/upcoming/${item.id}/cancel`);
      await loadSchedules();
    } catch (error) {
      console.error("Erro ao cancelar disparo:", error);
      alert("Não foi possível cancelar o disparo. Atualize a tela e tente novamente.");
    }
  };

  return (
    <div
      style={{
        marginTop: 24,
        background: "#fff",
        borderRadius: 14,
        padding: 20,
        boxShadow: "0 2px 10px rgba(0,0,0,0.06)"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 12,
          alignItems: "center",
          marginBottom: 16
        }}
      >
        <div>
          <div style={{ fontSize: 13, color: "#64748b", fontWeight: 800 }}>
            Régua de Recuperação
          </div>
          <h2 style={{ margin: 0, fontSize: 22 }}>Próximos disparos da régua</h2>
          <div style={{ fontSize: 13, color: "#64748b" }}>
            Veja antes quem vai receber mensagem e qual texto será enviado, já sem o prefixo interno.
          </div>
        </div>

        <button
          type="button"
          onClick={loadSchedules}
          disabled={loading}
          style={{
            border: 0,
            borderRadius: 10,
            padding: "10px 16px",
            background: "#dc2626",
            color: "#fff",
            fontWeight: 800,
            cursor: loading ? "not-allowed" : "pointer"
          }}
        >
          {loading ? "Atualizando..." : "Atualizar"}
        </button>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1050 }}>
          <thead>
            <tr style={{ background: "#f8fafc", color: "#475569", textAlign: "left" }}>
              <th style={{ padding: 10 }}>Data envio</th>
              <th style={{ padding: 10 }}>Cliente</th>
              <th style={{ padding: 10 }}>Telefone</th>
              <th style={{ padding: 10 }}>Vendedor</th>
              <th style={{ padding: 10 }}>Mensagem que será enviada</th>
              <th style={{ padding: 10 }}>Status</th>
              <th style={{ padding: 10 }}>Ação</th>
            </tr>
          </thead>

          <tbody>
            {schedules.length === 0 && (
              <tr>
                <td colSpan="7" style={{ padding: 16, color: "#64748b", textAlign: "center" }}>
                  Nenhum disparo futuro encontrado.
                </td>
              </tr>
            )}

            {schedules.map(item => (
              <tr key={item.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                <td style={{ padding: 10, fontWeight: 800 }}>{formatDate(item.sendDate)}</td>
                <td style={{ padding: 10, fontWeight: 800 }}>{item.contactName || "-"}</td>
                <td style={{ padding: 10 }}>{item.contactNumber || "-"}</td>
                <td style={{ padding: 10 }}>{item.sellerName || "-"}</td>
                <td style={{ padding: 10, maxWidth: 420 }}>{item.cleanMessage || "-"}</td>
                <td style={{ padding: 10 }}>
                  <span
                    style={{
                      display: "inline-block",
                      borderRadius: 999,
                      padding: "5px 9px",
                      fontSize: 11,
                      fontWeight: 900,
                      background: "#fff3cd",
                      color: "#856404"
                    }}
                  >
                    {item.status}
                  </span>
                </td>
                <td style={{ padding: 10 }}>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <button
                      type="button"
                      onClick={() => openTicket(item.ticketUuid)}
                      disabled={!item.ticketUuid}
                      style={{
                        border: 0,
                        borderRadius: 8,
                        padding: "8px 12px",
                        background: item.ticketUuid ? "#111827" : "#cbd5e1",
                        color: "#fff",
                        fontWeight: 800,
                        cursor: item.ticketUuid ? "pointer" : "not-allowed"
                      }}
                    >
                      Abrir atendimento
                    </button>

                    <button
                      type="button"
                      onClick={() => cancelSchedule(item)}
                      style={{
                        border: 0,
                        borderRadius: 8,
                        padding: "8px 12px",
                        background: "#dc2626",
                        color: "#fff",
                        fontWeight: 800,
                        cursor: "pointer"
                      }}
                    >
                      Cancelar disparo
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecoveryUpcomingSchedules;
